// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { SEARCH_TAGS_ORDER_BY_KEY } from "../../../app/localStorageKeys"
import {
  SearchTagsRequest_OrderBy,
} from "generated/legebill/site/tag/v4/tag_pb"

export type StorageWriter = (value: SearchTagsRequest_OrderBy) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(SEARCH_TAGS_ORDER_BY_KEY, value.toString())
}

export const persistOrderBy = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setSearchOrderBy.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.orderByPersisted()),
        catchError(_ => of(Actions.orderByPersistFailed())),
      )),
    )

export default persistOrderBy(persist)

